<template>
	<div class="profile_fields">
		<field
				width="100%"
				margin="0 0 10px 0"
				label="Email"
				placeholder="Enter email"
				:setInputValue="manager ? manager.email : email"
				:is-clip="!!manager"
				is-disabled
		></field>
			
	  <field
			  margin="0"
			  width="100%"
			  :label="manager ? 'Phone' : 'User role'"
			  :setInputValue="manager ? manager.phone : role"
			  :is-phone-link="!!manager"
	      :is-clip="!!manager"
			  is-disabled
	  ></field>
	</div>
</template>

<script>
export default {
	name: "ProfileFields",
	props: {
		email: String,
		role: String,
		manager: Object
	}
};
</script>

<style scoped lang="scss">
.profile_fields {
	padding: 20px;
	background: var(--card-bg);
	//box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.3);
	border-radius: 0 0 4px 4px;
}
</style>
